import { CartLinesUpdateEvent } from '@shopify/events';

class PcaCartAdd extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const { signal } = this.controller;

    this.addEventListener('change', (event) => {
      if (!(event.target instanceof Element)) return;
      if (!event.target.matches('[data-pca-select]')) return;
      this.updateSelection();
      const status = this.querySelector('[data-pca-status]');
      if (status && !this.busy) status.textContent = '';
    }, { signal });

    this.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('[data-pca-add]');
      if (!button || !this.contains(button)) return;
      event.preventDefault();
      this.addSelected();
    }, { signal });

    this.updateSelection();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
  }

  updateSelection() {
    const select = this.querySelector('[data-pca-select]');
    const button = this.querySelector('[data-pca-add]');
    if (!select || !button) return;

    const option = select.selectedOptions[0];
    const selected = Boolean(option?.value);
    select.disabled = Boolean(this.busy);
    button.disabled = Boolean(this.busy) || !selected;
    button.textContent = this.busy ? 'Añadiendo…' : 'Añadir al carrito';

    const hint = this.querySelector('[data-pca-threshold]');
    if (hint) {
 hint.hidden =
  !selected ||
  Number(this.dataset.remaining) <= 0 ||
  Number(option.dataset.price) < Number(this.dataset.remaining);

    }
    if (!selected) return;

    const price = this.querySelector('[data-pca-price]');
    if (price) price.textContent = option.dataset.money || '';
    this.querySelectorAll('[data-pca-link]').forEach((link) => {
      if (option.dataset.url) link.href = option.dataset.url;
    });
    const image = this.querySelector('.pca-complement__image');
    if (image && option.dataset.image) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = option.dataset.image;
    }
  }

  async addSelected() {
    const select = this.querySelector('[data-pca-select]');
    const variantId = select?.value;
    if (!variantId || this.busy) return;

    this.busy = true;
    this.updateSelection();
    const initialStatus = this.querySelector('[data-pca-status]');
    if (initialStatus) initialStatus.textContent = '';

    let deferred;
    let added = false;
    let message = '';

    try {
      const sectionIds = new Set(['cart-drawer-section']);
      document.querySelectorAll('cart-items-component').forEach((item) => {
        if (item.dataset.sectionId) sectionIds.add(item.dataset.sectionId);
      });

      deferred = CartLinesUpdateEvent.createPromise();
      deferred.promise.catch(() => {});
      this.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: variantId, quantity: 1 }],
        promise: deferred.promise,
      }));

      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: [...sectionIds].slice(0, 5),
          sections_url: window.location.pathname,
        }),
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(typeof result.description === 'string'
          ? result.description
          : 'No se ha podido añadir esta opción. Revisa su disponibilidad.');
      }
      added = true;

      const cartResponse = await fetch(`${Theme.routes.cart_url}.json`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      });
      if (!cartResponse.ok) throw new Error('No se ha podido refrescar el carrito.');
      const cart = await cartResponse.json();

      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'product-form-component',
          sourceId: `pca-cart-add-${this.dataset.productId}`,
          itemCount: 1,
          productId: this.dataset.productId,
          sections: result.sections,
          didError: false,
        },
      });
      message = 'Producto añadido al carrito.';
    } catch (error) {
      deferred?.reject(error);
      console.error('[pca-cart-add]', error);
      message = added
        ? 'El producto se ha añadido, pero no se ha podido refrescar el carrito. Recarga la página antes de añadir otro.'
        : error.message || 'No se ha podido añadir el producto.';
    } finally {
      this.busy = false;
      if (this.isConnected) {
        const currentSelect = this.querySelector('[data-pca-select]');
        if (added && currentSelect) currentSelect.value = '';
        this.updateSelection();
        const currentStatus = this.querySelector('[data-pca-status]');
        if (currentStatus) currentStatus.textContent = message;
      }
    }
  }
}

if (!customElements.get('pca-cart-add')) {
  customElements.define('pca-cart-add', PcaCartAdd);
}